<jhi-button
    [disabled]="!exerciseId"
    [btnType]="ButtonType.INFO"
    [btnSize]="buttonSize"
    [shouldSubmit]="false"
    [featureToggle]="[FeatureToggle.ProgrammingExercises, FeatureToggle.Exports]"
    [icon]="faDownload"
    [title]="title"
    (onClick)="exportRepository()"
/>
